<mat-icon svgIcon="full-logo" class="logo"></mat-icon>
<div class="right">
    <div class="nav-links">
        <nav-link *ngFor="let n of navLinks" [navLink]="n"></nav-link>
    </div>
    <div class="contact-button" (click)="goForm()">
        <page-button text="Contáctame"></page-button>
    </div>
</div>